export const environment = {
  envName: "rijeka-dev",
  production: false,
  url: '',
  urlSuffix: "",
  paymentUrl: "https://pgw.ulaznice.dev/pgw-service",
  apiUrl: "https://api.test.ulaznice.hr/paganini",
  appId: "1",
  redirectUrl: "https://www.test.ulaznice.hr/nk-rijeka-intra",
  connId: "60",
  recaptchaSiteKey: "6LdghEQrAAAAAGznLjG5pIWKV2twdJ3wZ9HOmsD-",
  webSocketUrl: "wss://apps.test.ulaznice.hr/ws/",
  page: "rijeka",
  pageFolder: "sport",
  pageTitle: "HNK Rijeka",
  configId: "4",
  googleClientId: "785189596986-n1q65ceijpkm01kuo4lef08qrtfb5tog.apps.googleusercontent.com",
  facebookAppId: "451047933216100",
  officialWebsiteUrl: "https://nk-rijeka.hr/",
  becomingMemberDisabled: false,
};
